import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Row, Col, Button, FormControl, FormGroup, Collapse, Well, InputGroup, HelpBlock } from 'react-bootstrap';
import './Footer.css';
import GetInTouch from '../common/GetInTouch';
import instagram from '../../img/social-icons/instagram-icon.svg';
import twitter from '../../img/social-icons/twitter-icon.svg';
import linkedin from '../../img/social-icons/linkedin-icon.svg';
import facebook from '../../img/social-icons/facebook-icon.svg';
import arcnetwhite from '../../img/arcnet-white.png';
import Logo from './DistilledIdLogo';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      validEmail: true,
      contactopen: true,
      aboutopen: true,
      platformopen: true,
    };
  }

  onClickSubmit(e) {
    e.preventDefault();
    this.validateForm();
  }

  isEmailValid(email) {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  }

  validateForm() {
    const {
      email,
    } = this.state;
    this.setState({
      validEmail: this.isEmailValid(email),
    });
  }

  render() {
    return (
      <div className="footer" >
        {
          this.props.showGetInTouch &&
          <GetInTouch />
        }
        <Grid >
          <div className="logo" >
            <Logo height={14} />
          </div>
          <Row className="footer-wrapper">
            <Col md={3} xs={12} id="contact" className="footer-section" >
              <Button
                className="footer-link"
                onClick={() => this.setState({ contactopen: !this.state.contactopen })}
                disabled={window.innerWidth > 768}
              >
                CONTACT
                {this.state.contactopen ?
                  <i className="glyphicon glyphicon-menu-down" /> :
                  <i className="glyphicon glyphicon-menu-up" />}
              </Button>
              <Collapse in={window.innerWidth > 768 ?
                this.state.contactopen :
                !this.state.contactopen}
              >
                <div>
                  <Well>
                    <span>UK: +44 (0)131 2255558</span>
                    <a
                      className="email-link"
                      href="mailto:info@distilledID.com">
                      info@distilledID.com
                    </a>
                    <address>
                      DistilledID <br />
                      No. 2 Lochrin Square, <br />
                      96 Fountainbridge <br />
                      Edinburgh, EH3 9QA
                    </address>
                  </Well>
                </div>
              </Collapse>
            </Col>
            <Col md={2} xs={12} id="about" className="footer-section">

              <Button
                className="footer-link"
                onClick={() => this.setState({ aboutopen: !this.state.aboutopen })}
                disabled={window.innerWidth > 768}
              >
                ABOUT
                {this.state.aboutopen ?
                  <i className="glyphicon glyphicon-menu-down" /> :
                  <i className="glyphicon glyphicon-menu-up" />}
              </Button>
              <Collapse in={window.innerWidth > 768 ? this.state.aboutopen : !this.state.aboutopen}>
                <div>
                  <Well>
                    <Link to="/about" className="link">About</Link>
                    <Link to="/news" className="link">News</Link>
                    <Link to={{ pathname: '/about', hash: 'media-kit' }} className="link">Media Kit</Link>
                    <Link to="/careers" className="link">Careers</Link>
                    <Link to="/graduates" className="link">Graduates</Link>
                    <Link to="/privacy" className="link">Privacy</Link>
                  </Well>
                </div>
              </Collapse>
            </Col>
            <Col md={3} xs={12} id="platform" className="footer-section" >
              <Button
                className="footer-link"
                onClick={() => this.setState({ platformopen: !this.state.platformopen })}
                disabled={window.innerWidth > 768}
              >
                PLATFORM
                {this.state.platformopen ?
                  <i className="glyphicon glyphicon-menu-down" /> :
                  <i className="glyphicon glyphicon-menu-up" />}
              </Button>
              <Collapse
                in={window.innerWidth > 768 ? this.state.platformopen : !this.state.platformopen}
              >
                <div>
                  <Well>
                    <Link to={{ pathname: '/home', hash: 'distillerymanagementplatform' }} className="link">Distillery Management Platform </Link>
                    <Link to={{ pathname: '/home', hash: 'consumerexperience' }} className="link">Storybook</Link>
                    <Link to={{ pathname: '/home', hash: 'consumerintelligence' }} className="link">Consumer Intelligence</Link>
                    <Link to="/case_studies" className="link">Case Studies</Link>
                  </Well>
                </div>
              </Collapse>
            </Col>
            <Col md={4} xs={12} id="subscribe" className="newsletter-section" >
              <h5 className="footer-heading"> Subscribe to our newsletter </h5>
              <span>
                Get stories on whisky, spirits, and product updates,
                straight to your inbox.
              </span>
              <div className="formbox">
                <form
                  className="form"
                  action="https://distilledid.us19.list-manage.com/subscribe/post?u=6e0c08acecd6f451122ecc6f7&amp;id=66bf4fdc88"
                  method="post"
                >
                  <FormGroup
                    validationState={this.state.email ? null : 'error'}
                  >
                    <InputGroup>
                      <FormControl
                        className="email"
                        type="text"
                        id="mce-EMAIL"
                        name="EMAIL"
                        value={this.state.email}
                        placeholder="yourname@email.com"
                        onChange={(e) => {
                          this.setState({
                            email: e.target.value,
                            validEmail: this.isEmailValid(e.target.value),
                          });
                        }}
                      />
                      <InputGroup.Button>
                        <Button
                          className="email-submit"
                          type="submit"
                          value="Subscribe"
                          name="subscribe"
                          disabled={!this.isEmailValid(this.state.email)}
                        >
                          Submit
                        </Button>
                      </InputGroup.Button>
                      {!this.state.validEmail && <HelpBlock>Valid email is required</HelpBlock>}
                    </InputGroup>
                  </FormGroup>
                </form>
              </div>
              <div>
                <a href="https://www.facebook.com/distilledID" target="_blank" rel="noopener noreferrer">
                  <img src={facebook} className="social-icon " alt="facebook" />
                </a>
                <a href="https://twitter.com/distilledID" target="_blank" rel="noopener noreferrer">
                  <img src={twitter} className="social-icon" alt="twitter" />
                </a>
                <a href="https://www.instagram.com/distilledID" target="_blank" rel="noopener noreferrer">
                  <img src={instagram} className="social-icon" alt="twitter" />
                </a>
                <a href="https://www.linkedin.com/company/distilled-id/about/" target="_blank" rel="noopener noreferrer">
                  <img src={linkedin} className="social-icon" alt="linkedin" />
                </a>
              </div>
            </Col>
          </Row>
          <Row className="footer-bottom">
            <Col md={6} xs={12}>
              © Distilled ID | All rights reserved.
            </Col>
            <Col md={6} sm={6} xs={12}>
              <div className="powered-by">
                powered by
          <img src={arcnetwhite} className="arcnet-logo" alt="arc-net logo" />
              </div>
            </Col>
          </Row>
        </Grid >
      </div >
    );
  }
}

export default Footer;




// WEBPACK FOOTER //
// ./src/components/common/Footer.js